import styled from "@emotion/styled";

export const StyledToggle = styled.input(({ theme }) => ({
  appearance: "none",
  border: "none",
  cursor: "pointer",
  padding: "2px",
  width: "32px",
  height: "16px",
  backgroundColor: theme.colors.icon.placeholder,
  borderRadius: "100px",
  flexShrink: 0,
  margin: "0px",
  position: "relative",
  transition: "all 100ms ease-out 0s",

  ":before": {
    position: "absolute",
    content: '""',
    inset: "-4px",
    pointerEvents: "none",
  },
  ":after": {
    content: '""',
    position: "absolute",
    top: "2px",
    left: "2px",
    background: theme.colors.icon.onAccent,
    width: "12px",
    height: "12px",
    borderRadius: "50%",
    transition: "all 100ms ease-out 0s",
    pointerEvents: "none",
  },
  ":checked": {
    backgroundColor: theme.colors.icon.selected,

    "&::after": {
      left: "18px",
    },
  },
}));
